'use client';

import ChevronLeft from '@modules/common/icons/chevron-left';
import { useState } from 'react';
import type { ImageGalleryProps } from '.';
import Thumbnails from './thumbnails';
import ZoomableImage from './zoomable-image';

export const DesktopImageGallery = ({
  images,
  productTitle,
}: ImageGalleryProps) => {
  const [selectedImage, setSelectedImage] = useState(0);
  const handleImageEnter = (index: number) => setSelectedImage(index);

  return (
    <section
      aria-label={`${productTitle} images`}
      aria-roledescription="carousel"
    >
      <div aria-atomic="true" aria-live="polite" className="sr-only">
        {`Photo ${selectedImage + 1} of ${images.length}`}
      </div>
      <div className="hidden gap-3 medium:gap-5 desktop:flex">
        {images.length > 1 && (
          <Thumbnails
            currentIndex={selectedImage}
            images={images}
            onChange={handleImageEnter}
          />
        )}
        <div className="relative">
          <ZoomableImage
            images={images}
            preload={selectedImage === 0}
            productTitle={productTitle}
            selectedImage={selectedImage}
          />
          {images.length > 1 && (
            <>
              <button
                aria-label="Previous photo"
                className="absolute left-4 top-1/2 z-10 flex size-8 -translate-y-1/2 items-center justify-center rounded-full border border-brand-primary-100 bg-white p-1 disabled:cursor-not-allowed disabled:opacity-50"
                disabled={selectedImage === 0}
                onClick={() => handleImageEnter(selectedImage - 1)}
                type="button"
              >
                <ChevronLeft size="24" className="mr-[2px]" />
              </button>
              <button
                aria-label="Next photo"
                className="absolute right-4 top-1/2 z-10 flex size-8 -translate-y-1/2 items-center justify-center rounded-full border border-brand-primary-100 bg-white p-1 disabled:cursor-not-allowed disabled:opacity-50"
                disabled={selectedImage === images.length - 1}
                onClick={() => handleImageEnter(selectedImage + 1)}
                type="button"
              >
                <ChevronLeft size="24" className="rotate-180 ml-[2px]" />
              </button>
            </>
          )}
        </div>
      </div>
    </section>
  );
};
